import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { WhatIfSection } from './components/WhatIfSection';
import { PainSection } from './components/PainSection';
import { KnowingSection } from './components/KnowingSection';
import { TurnSection } from './components/TurnSection';
import { SystemIntro } from './components/SystemIntro';
import { ModulesSection } from './components/ModulesSection';
import { PreviewSection } from './components/PreviewSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionSection } from './components/ObjectionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '2006836796695731';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="85ui3o9tht28">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="85bbv4tj4t41" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory" data-id="element-2" data-mp="3bnmgpliglb9e">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="3qbzgktko3e96" />}
        <main data-id="element-4" data-mp="3qcipxlw94ubl">
          <Hero data-id="element-5" data-mp="3qd0tz4p5ocu2" />
          <WhatIfSection data-id="element-6" data-mp="3lkr41oo1jcrs" />
          <PainSection data-id="element-7" data-mp="3ljg27ue5of3b" />
          <KnowingSection data-id="element-8" data-mp="3liwgs3par8kj" />
          <TurnSection data-id="element-9" data-mp="3limv2sbabnkn" />
          <SystemIntro data-id="element-10" data-mp="2xud9nrhzh1u1" />
          <ModulesSection data-id="element-11" data-mp="2xtlqxh9hiyl6" />
          <PreviewSection data-id="element-12" data-mp="2xt253pgprq1v" />
          <BonusSection data-id="element-13" data-mp="2svtqtzyos65w" />
          <BenefitsSection data-id="element-14" data-mp="2swliizp5xjqw" />
          <ObjectionSection data-id="element-15" data-mp="2svafx37gei1d" />
          <BeforeAfterSection data-id="element-16" data-mp="2stzbd166p697" />
          <PricingSection data-id="element-17" data-mp="18d9haio8i6xz" />
          <Guarantee data-id="element-18" data-mp="18czpcpjmpppn" />
          <Testimonials data-id="element-19" data-mp="18boi2fqz5zts" />
          <FAQ data-id="element-20" data-mp="1d4hqbdlnjqam" />
          <FinalCTA data-id="element-21" data-mp="1d4zuqxigxatm" />
        </main>
        <Footer data-id="element-22" data-mp="1d62gys4uip37" />
      </div>
    </>;
}